<template v-if="tipoPublicacion == ''">
    <el-col :xs="24" :md="12" :cols="12">
        <div id="colderecha" v-if="tipoPublicacion == ''">
            <div class="clearfix">
                <h2 style="padding-left: 10px;">Listado de publicaciones</h2>
            </div>
            <ul style="padding: 0px;" class="contenedorpublicaciones" v-loading="loading">
                <li v-for="carpeta in carpetas.filter((carpeta) => { return carpeta.type == 'publicacion' })" :key="carpeta.nombre" @click="tipoPublicacion = carpeta.carpeta" class="tipodocumento">
                    <div style="display:flex">
                        <div class="iconoconsulta">
                            <img :src="`${urlportal}/assets/img/${carpeta.carpeta}.png`" width="70%" />
                        </div>
                        <p>{{carpeta.nombre}}</p>
                    </div>
                    <hr style="border:none">
                    <span style="font-weight:normal">{{ carpeta.description }}</span>
                </li>
                <div style="padding: 10px; width: 100%">
                    <el-button type="primary" style="width: 100%" @click="$router.go(-1)"><font-awesome-icon
                            style="margin-right: 5px;" :icon="['fas', 'angle-left']" /> Volver</el-button>
                </div>
            </ul>
        </div>
        <div style="display: flex; flex-direction: column; align-items: center; padding: 10px;" id="colderecha"
            v-if="tipoPublicacion != '' && idVer == ''">
            <div class="clearfix">
                <h2>Listado de {{ tipoPublicacion }}</h2>
            </div>
            <ul v-loading="loading"
                style="list-style: none; width: 100%; max-width: 550px; padding: 0px 10px; display:flex; flex-direction: column; height: 400px; overflow-y:auto;">
                <li v-for="(post, index) in publicaciones[tipoPublicacion]" :key="post + index"
                    @click="idVer = index + 1" class="tipodocumento">
                    <div style="display:flex">
                        <div class="iconoconsulta">
                            <img src="@/assets/new/verpublicaciones.png" width="70%" />
                        </div>
                        <p>{{ post.post_title }}</p>
                    </div>
                </li>
                <el-alert v-if="publicaciones[tipoPublicacion].length == 0" title="¡Oops!" type="info"
                    :description="`No se han encontrado ${tipoPublicacion}`" show-icon :closable="false">
                </el-alert>
            </ul>
            <el-button style="width: 100%; max-width: 550px;" @click="tipoPublicacion = ''"
                type="primary"><font-awesome-icon style="margin-right: 5px;" :icon="['fas', 'angle-left']" />
                Volver</el-button>
        </div>
        <div id="colderecha" style="padding: 10px;"
            v-if="tipoPublicacion != '' && idVer != '' && publicacionFiltrada && publicacionFiltrada.post_title">
            <div v-loading="loading">
                <div class="clearfix">
                    <h2>{{ publicacionFiltrada.post_title }}</h2>
                </div>
                <div v-if="!categorias" style="width: 100%; max-height: 500px; overflow-y:auto;">
                    <template v-if="publicacionFiltrada.content_type === 'pdf'">
                        <iframe :src="urlportal + '/' + publicacionFiltrada.post_content"
                            style="width: 100%; height: 70dvh; border: none;" allowfullscreen>
                        </iframe>
                    </template>
                    <template v-else>
                        <div v-html="publicacionFiltrada.post_content"></div>
                    </template>
                </div>
                <div v-if="categorias" style="width: 100%; max-height: 500px; overflow-y:auto; text-align:left;">
                    <ul>
                        <li :style="publicacionFiltrada.permisos && publicacionFiltrada.permisos.empresas && publicacionFiltrada.permisos.empresas.includes('' + empresa.id) ? 'color: #4cd137' : 'color:#e84118'"
                            v-for="empresa in empresasAgrupadas" :key="'empresa' + empresa.id">{{ empresa.nombre }}
                            <ul>
                                <li :style="(publicacionFiltrada.permisos && publicacionFiltrada.permisos.empresas && publicacionFiltrada.permisos.empresas.includes('' + empresa.id))
                                    || (publicacionFiltrada.permisos && publicacionFiltrada.permisos.areas && publicacionFiltrada.permisos.areas.includes('' + area.id)) ? 'color: #4cd137' : 'color:#e84118'"
                                    v-for="area in empresa.areas" :key="'area' + area.id">{{ area.nombre }}
                                    <ul>
                                        <li :style="(publicacionFiltrada.permisos && publicacionFiltrada.permisos.empresas && publicacionFiltrada.permisos.empresas.includes('' + empresa.id))
                                            || (publicacionFiltrada.permisos && publicacionFiltrada.permisos.areas && publicacionFiltrada.permisos.areas.includes('' + area.id)) ||
                                            (publicacionFiltrada.permisos && publicacionFiltrada.permisos.centros && publicacionFiltrada.permisos.centros.includes('' + centro.id)) ? 'color: #4cd137' : 'color:#e84118'"
                                            v-for="centro in area.centros" :key="'centro' + centro.id">{{ centro.nombre
                                            }}</li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                    </ul>
                    <ul>
                        <li :style="publicacionFiltrada.permisos && publicacionFiltrada.permisos.departamentos && publicacionFiltrada.permisos.departamentos.includes('' + departamento.id) ? 'color: #4cd137' : 'color:#e84118'"
                            v-for="departamento in departamentosAgrupados" :key="'departamento' + departamento.id">{{
                                departamento.nombre }}
                        </li>
                    </ul>
                </div>
                <div style="display:flex; margin-top: 10px;">
                    <el-button v-if="!categorias" style="width: 100%;" @click="eliminarPublicacion(publicacionFiltrada)"
                        type="danger">Eliminar publicación</el-button>
                    <el-button v-if="!categorias" style="width: 100%;" @click="categorias = true" type="warning">¿Quién
                        puede ver
                        esto?</el-button>
                    <el-button v-if="categorias" style="width: 100%;" @click="categorias = false"
                        type="primary"><font-awesome-icon style="margin-right: 5px;" :icon="['fas', 'chevron-left']" />
                        Volver</el-button>
                </div>
                <el-button style="position:absolute; left:calc(50% + 10px); top: 10px;" @click="idVer = ''"
                    type="success" circle><font-awesome-icon :icon="['fas', 'arrow-left']" /></el-button>
            </div>
        </div>
    </el-col>
</template>

<script>
import { mapMutations } from 'vuex'
import { mapState } from 'vuex'
export default {
    name: 'ListadoPublicaciones',
    data() {
        return {
            loading: true,
            navegacion: {
                indices: [],
                tabs: []
            },
            cargando: false,
            publicaciones: [],
            tipoPublicacion: '',
            idVer: '',
            categorias: 0,
            urlportal: process.env.VUE_APP_PORTAL,
        }
    },
    mounted() {
        this.init();
    },
    computed: {
        ...mapState([
            'datosemp', 'receptores', 'configEnvio', 'files', 'datos', 'carpetas'
        ]),
        publicacionFiltrada() {
            return this.publicaciones[this.tipoPublicacion][this.idVer - 1];
        },
        empresasAgrupadas() {
            let empresas = this.receptores.filter((empresa) => { return empresa.tipo == 'empresa' })
            empresas.forEach((empresa) => {
                empresa.areas = this.receptores.filter((area) => { return area.tipo == 'área' && area.empresa_id == empresa.id });
                empresa.areas.forEach((area) => {
                    area.centros = this.receptores.filter((centro) => { return centro.tipo == 'centro' && centro.area_id == area.id })
                })
            })
            return empresas;
        },
        departamentosAgrupados() {
            let departamentos = this.receptores.filter((dpt) => { return dpt.tipo == 'departamento' })
            return departamentos;
        }
    },
    methods: {
        ...mapMutations([
            'setDatosemp',
            'setReceptores'
        ]),
        comprobarDisponibilidad(data) {
            if (!this.publicaciones.permisos) {
                return false;
            }
            switch (data.tipo) {
                case 'empresa':
                    console.log(data.nombre);
                    if (this.publicacionFiltrada.permisos.empresas && this.publicacionFiltrada.permisos.empresas.includes('' + data.id)) {
                        console.log(data.nombre);
                        return true;
                    }
                    return false;
                case 'área':
                    if (this.publicacionFiltrada.permisos.areas && this.publicacionFiltrada.permisos.areas.includes('' + data.id)) {
                        return true;
                    }
                    return false;
                case 'centro':
                    if (this.publicacionFiltrada.permisos.centros && this.publicacionFiltrada.permisos.centros.includes('' + data.id)) {
                        return true;
                    }
                    return false;
            }
        },
        async init() {
            this.loading = true;
            await this.obtenerPublicaciones();
            this.loading = false;
        },
        async eliminarPublicacion(post) {
            let response = await fetch(process.env.VUE_APP_PORTAL + '/api/publicaciones/publicacion/' + post.id, {
                "method": "DELETE"
            });
            if (response.status == 200) {
                await this.obtenerPublicaciones();
                this.idVer = '';
                this.$notify({
                    title: '¡Bien!',
                    message: 'Publicación eliminada correctamente',
                    type: 'success'
                });
            }
        },
        async obtenerPublicaciones() {
            this.loading = true;
            let resp = await fetch(process.env.VUE_APP_PORTAL + '/api/publicaciones/obtenerTodasPublicaciones', {
                method: 'GET', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Content-Type': 'application/json'
                    // 'Content-Type': 'application/x-www-form-urlencoded',
                }
            });
            if (resp.status == 200) {
                resp = await resp.json();
                this.carpetas.forEach((carpeta) => {
                    this.publicaciones[carpeta.carpeta] = resp.filter((pub) => { return pub.post_type == carpeta.carpeta });
                })
            }
            this.loading = false;
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.contenedorpublicaciones {
    width: calc(100% - 10px);
    list-style: none;
    padding-inline-start: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    gap: 2.5px;

    li {
        flex-basis: calc(50% - 20px);
        /* Ajusta este valor según tus necesidades */
        box-sizing: border-box;
        aspect-ratio: 3/1;

        div {
            display: flex;
            align-items: center;
            text-align: left;
        }

        p {
            margin: 0px;
        }
    }
}

.tipodocumento {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    padding: 10px;
    border: 2px solid #a9a9a929;
    margin-bottom: 10px;
    border-radius: 10px;
    font-weight: bold;
    transition: 0.5s;
    justify-content: flex-start;

    &:hover {
        background-color: #a9a9a929;
        border-color: #a9a9a929;
    }

    .iconoconsulta {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 50px;
        height: 50px;
        background: rgba(9, 133, 227, 0.1450980392);
        border-radius: 10px;
        margin-right: 10px;
    }
}
</style>